import { Component, EventEmitter, Input, input, Output } from '@angular/core';

@Component({
  selector: 'app-btn-action',
  standalone: true,
  templateUrl: './btn-action.component.html',
  styleUrls: ['./btn-action.component.css'],
})
/**
 * Button component for actions
 * @example
 * <app-btn-action
 *   [label]="'Submit'"
 *   [isDisabled]="false"
 *   [inProgress$]="isLoading$"
 *   [icon]="'fas fa-save'"
 *   [suffixIcon]="''"
 *   [textColor]="'text-white'"
 *   [bgColor]="'bg-secondary-500 hover:bg-secondary-400 active:bg-primary-500'"
 *  (clicked)="onClick()"
 * ></app-btn-action>
 * @description
 * This component is used to create a button with an icon and text.
 * It can be used for actions like submit, save, delete, etc.
 * The button can be disabled and can show a loading spinner when in progress.
 * The button can also have a suffix icon.
 * The button can be styled with different colors for text and background.
 * The button can also have a click event.
 * The button can also have a loading spinner when in progress.
 * The button can also have a suffix icon.
 */
export class BtnActionComponent {
  label = input.required<string>();

  @Input() isDisabled: boolean = false;
  @Input() inProgress: boolean = false;

  icon = input<string>();
  suffixIcon = input<string>('');
  fullWidth = input<boolean>(false);
  shadow = input<boolean>(true);
  textColor = input<string>(
    'text-white disabled:text-primary-500 hover:text-white',
  );
  textStyle = input<string>('font-semibold');
  padding = input<string>('px-4 py-1');
  bgColor = input<string>(
    'bg-secondary-500 hover:bg-secondary-700 disabled:bg-gray-200 active:bg-primary-500',
  );

  @Output() clicked: EventEmitter<any> = new EventEmitter();

  onClick(): void {
    this.clicked.emit();
  }
}
